import {
  getAllNotifications,
  addNotification,
  updateNotification,
  getNotificationById,
  deleteNotificationById,
  getAllUserNotifications,
  markAsReadNotification,
  publishNotification,
} from "./NotificationsActions";
import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  notifications: any[] | null;
  notificationsLoading: boolean;
  notificationsError: any | null;

  notificationByIdData: any | null;
  notificationByIdLoading: boolean;
  notificationByIdError: any | null;

  addNotificationLoading: boolean;
  addNotificationError: any | null;
  addNotificationData: any | null;

  updateNotificationLoading: boolean;
  updateNotificationError: any | null;
  updateNotificationData: any | null;

  deleteNotificationByIdLoading: boolean;
  deleteNotificationByIdError: any | null;
  deleteNotificationByIdData: any | null;

  userNotifications: any[] | null;
  userNotificationsLoading: boolean;
  userNotificationsError: any | null;

  markAsReadNotificationLoading: boolean;
  markAsReadNotificationError: any | null;
  markAsReadNotificationData: any | null;

  publishNotificationLoading: boolean;
  publishNotificationError: any | null;
  publishNotificationData: any | null;
}

const initialState: InitialState = {
  notifications: null,
  notificationsLoading: false,
  notificationsError: null,

  notificationByIdData: null,
  notificationByIdLoading: false,
  notificationByIdError: null,

  addNotificationLoading: false,
  addNotificationError: null,
  addNotificationData: null,

  updateNotificationLoading: false,
  updateNotificationError: null,
  updateNotificationData: null,

  deleteNotificationByIdLoading: false,
  deleteNotificationByIdError: null,
  deleteNotificationByIdData: null,

  userNotifications: null,
  userNotificationsLoading: false,
  userNotificationsError: null,

  markAsReadNotificationLoading: false,
  markAsReadNotificationError: null,
  markAsReadNotificationData: null,

  publishNotificationLoading: false,
  publishNotificationError: null,
  publishNotificationData: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllNotifications.pending, (state) => {
      state.notificationsLoading = true;
      state.notificationsError = null;
      state.notifications = null;
    });
    builder.addCase(getAllNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload;
      state.notificationsLoading = false;
      state.notificationsError = null;
    });
    builder.addCase(getAllNotifications.rejected, (state, action) => {
      state.notificationsError = action.error;
      state.notificationsLoading = false;
      state.notifications = null;
    });

    builder.addCase(getNotificationById.pending, (state) => {
      state.notificationByIdLoading = true;
      state.notificationByIdError = null;
      state.notificationByIdData = null;
    });
    builder.addCase(getNotificationById.fulfilled, (state, action) => {
      state.notificationByIdData = action.payload;
      state.notificationByIdLoading = false;
      state.notificationByIdError = null;
    });
    builder.addCase(getNotificationById.rejected, (state, action) => {
      state.notificationByIdError = action.error;
      state.notificationByIdLoading = false;
      state.notificationByIdData = null;
    });

    builder.addCase(addNotification.pending, (state) => {
      state.addNotificationLoading = true;
      state.addNotificationError = null;
      state.addNotificationData = null;
    });
    builder.addCase(addNotification.fulfilled, (state, action) => {
      state.addNotificationData = action.payload;
      state.addNotificationLoading = false;
      state.addNotificationError = null;
    });
    builder.addCase(addNotification.rejected, (state, action) => {
      state.addNotificationError = action.error;
      state.addNotificationLoading = false;
      state.addNotificationData = null;
    });

    builder.addCase(updateNotification.pending, (state) => {
      state.updateNotificationLoading = true;
      state.updateNotificationError = null;
      state.updateNotificationData = null;
    });
    builder.addCase(updateNotification.fulfilled, (state, action) => {
      state.updateNotificationData = action.payload;
      state.updateNotificationLoading = false;
      state.updateNotificationError = null;
    });
    builder.addCase(updateNotification.rejected, (state, action) => {
      state.updateNotificationError = action.error;
      state.updateNotificationLoading = false;
      state.updateNotificationData = null;
    });

    builder.addCase(deleteNotificationById.pending, (state) => {
      state.deleteNotificationByIdLoading = true;
      state.deleteNotificationByIdError = null;
      state.deleteNotificationByIdData = null;
    });
    builder.addCase(deleteNotificationById.fulfilled, (state, action) => {
      state.deleteNotificationByIdData = action.payload;
      state.deleteNotificationByIdLoading = false;
      state.deleteNotificationByIdError = null;
    });
    builder.addCase(deleteNotificationById.rejected, (state, action) => {
      state.deleteNotificationByIdError = action.error;
      state.deleteNotificationByIdLoading = false;
      state.deleteNotificationByIdData = null;
    });

    builder.addCase(getAllUserNotifications.pending, (state) => {
      state.userNotificationsLoading = true;
      state.userNotificationsError = null;
      state.userNotifications = null;
    });
    builder.addCase(getAllUserNotifications.fulfilled, (state, action) => {
      state.userNotifications = action.payload;
      state.userNotificationsLoading = false;
      state.userNotificationsError = null;
    });
    builder.addCase(getAllUserNotifications.rejected, (state, action) => {
      state.userNotificationsError = action.error;
      state.userNotificationsLoading = false;
      state.userNotifications = null;
    });

    builder.addCase(markAsReadNotification.pending, (state) => {
      state.markAsReadNotificationLoading = true;
      state.markAsReadNotificationError = null;
      state.markAsReadNotificationData = null;
    });
    builder.addCase(markAsReadNotification.fulfilled, (state, action) => {
      state.markAsReadNotificationData = action.payload;
      state.markAsReadNotificationLoading = false;
      state.markAsReadNotificationError = null;
    });
    builder.addCase(markAsReadNotification.rejected, (state, action) => {
      state.markAsReadNotificationError = action.error;
      state.markAsReadNotificationLoading = false;
      state.markAsReadNotificationData = null;
    });

    builder.addCase(publishNotification.pending, (state) => {
      state.publishNotificationLoading = true;
      state.publishNotificationError = null;
      state.publishNotificationData = null;
    });
    builder.addCase(publishNotification.fulfilled, (state, action) => {
      state.publishNotificationData = action.payload;
      state.publishNotificationLoading = false;
      state.publishNotificationError = null;
    });
    builder.addCase(publishNotification.rejected, (state, action) => {
      state.publishNotificationError = action.error;
      state.publishNotificationLoading = false;
      state.publishNotificationData = null;
    });
  },
});

const notificationsReducer = notificationsSlice.reducer;

export default notificationsReducer;
